import { IObjProps } from 'shared/consts/types';

import { RootState } from 'store/rootReducer';

export const allAvailableFlows = (state: RootState) =>
	state.PathBuilder.flows.data.map((flow: any) => ({
		id: flow.path_key,
		label: flow.display_name,
	}));

export const pathBuilderBotRef = (state: RootState) => state.PathBuilder.botRef;
export const pathFlowAttributes = (state: RootState) => state.PathBuilder.flowAttributes;
export const allAttributes = (state: RootState) =>
	state.PathBuilder.allAttributes.map((attribute: IObjProps) => ({
		id: attribute.id,
		label: attribute.name,
	}));

export const availablePathVariables = (state: RootState) => state.PathBuilder.pathVariables;
export const flowDataPathKey = (state: RootState) => state.PathBuilder.flowData.data.path_key;
export const nodesList = (state: RootState) => state.PathBuilder.flowData.data.nodes;
export const flowsData = (state: RootState) => state.PathBuilder.flows.data;
export const pathBuilderVariables = (state: RootState) => state.PathBuilder.pathVariables;
export const analyticsEnabled = (state: RootState) => state.Bot.data.is_analytics_enabled;
export const campaigns = (state: RootState) => state.Broadcast.campaigns;
export const highlightedNodeIndex = (state: RootState) => state.PathBuilder.highlightedNode.index;
export const nodesAttrListData = (state: RootState) => state.PathBuilder.nodesAttrList.data;
export const selectedNode = (state: RootState) => state.PathBuilder.selectedNode;
export const zoomScale = (state: RootState) => state.PathBuilder.globalZoomScale;
